import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import "./engagement-count.m.css";

class EngagementCountBase extends React.Component {
  constructor() {
    super();
    this.state = {
      shrubberyEngagement: 0,
      facebookEngagement: 0
    };
    this.engagement_total = "";
    this.totalEngagementCount = this.totalEngagementCount.bind(this);
    this.getStoryEngagementCount = this.getStoryEngagementCount.bind(this);
  }
  componentDidMount() {
    this.getStoryEngagementCount();
  }
  getStoryEngagementCount() {
    return global
      .wretch(`/api/stories/${this.props.storyId}/engagement`)
      .query({
        fields: "facebook,shrubbery"
      })
      .get()
      .json(response => {
        this.setState({
          facebookEngagement: response.facebook.engagement,
          shrubberyEngagement: response.shrubbery.views
        });
      });
  }

  totalEngagementCount() {
    this.engagement_total = this.state.facebookEngagement + this.state.shrubberyEngagement;
    if (this.engagement_total > 50) {
      if (this.engagement_total > 999 && this.engagement_total <= 999999) {
        return (this.engagement_total = this.engagement_total / 1000 + " K ");
      } else if (this.engagement_total > 999999) {
        return (this.engagement_total = this.engagement_total / 1000000 + " M ");
      }
      return (this.engagement_total = this.engagement_total);
    } else {
      return this.engagement_total;
    }
  }
  render() {
    const langClassName = this.props.publisherAttributes.lang === "ur" ? "urdu-engagement-count" : null;
    return (
      <div styleName="user-engagement-count" className={langClassName}>
        <span>Engagement: </span>
        <span>{this.totalEngagementCount()}</span>
      </div>
    );
  }
}

EngagementCountBase.propTypes = {
  storyId: PropTypes.string,
  publisherAttributes: PropTypes.object
};
function mapStateToProps(state) {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], [])
  };
}
export const EngagementCount = connect(
  mapStateToProps,
  null
)(EngagementCountBase);
